define((require) => {
    "use strict";

    const Backbone          = require("backbone");
    const User              = require("editor/ui/user/User");
    const LoggedInUserState = require("shared/ui/user/LoggedInUserState");
    const RestApi           = require("shared/services/RestApi");

    /**
     * A collection of users.
     *
     * @author Bruce Mackenzie Nielsen
     * @class UserCollection
     * @constructor
     */
    return Backbone.Collection.extend({
        model: User,

        url() {
            return RestApi.pathToCollection(RestApi.Collections.USERS);
        },

        byExcludingCurrentUser() {
            return new Backbone.Collection(this.filter((user) => {
                const currentUserId = LoggedInUserState.get("user").get("id");
                return currentUserId !== user.get("id");
            }));
        },

        undeletedUsers() {
            return new Backbone.Collection(this.filter((user) => !user.get("deletedAt")));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/user/UserCollection.js